import { render, staticRenderFns } from "./prod-icon.vue?vue&type=template&id=8edc9ec0&scoped=true"
import script from "./prod-icon.vue?vue&type=script&lang=js"
export * from "./prod-icon.vue?vue&type=script&lang=js"
import style0 from "./prod-icon.vue?vue&type=style&index=0&id=8edc9ec0&prod&scoped=scoped&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8edc9ec0",
  null
  
)

export default component.exports